module.exports = __webpack_public_path__ + "static/media/whichThinnerDietaryChanges.c5dbc085.mp3";